import createConsts from '../../utils/redux/consts';
import { createActions } from '../../utils/redux';

/*
 * TODO: location change handling
 */

const supportedActions = ['SET', 'UPDATE', 'REMOVE'];

export const consts = createConsts(
  'context',
  'targetUser',
  ...supportedActions,
);
export const actions = createActions(consts);

const initialState = {};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case consts.SET:
    case consts.UPDATE:
      return payload;
    case consts.REMOVE:
      return initialState;
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/context/targetUser.js